import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHandHoldingDollar, faCircleNotch, faWallet, faCreditCard, faArrowUpFromBracket, faBitcoinSign, faBank, faArrowRight, faUser, faUsd } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import { useNavigate, useLocation, Link } from 'react-router-dom'
import { getCurrencySymbol, formatCurrency, getRate } from '../utils/currencyUtils';
import { toast } from 'react-hot-toast';

function Deposit1() {
  const { user } = useUser();
  const [loading, setLoading] = useState(true);
  const { state } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const lsType = localStorage.getItem('deposit.route');
    const hasType = state?.route || lsType;
    if (!hasType) {
      navigate('/deposit', { replace: true });
    } else {
      setLoading(false);
    }
  }, [state, navigate]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
      const fetchRate = async () => {
        const r = await getRate(currencyCode);
        if (isMounted) setRate(r);
      };
      fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);
  const [activeTab, setActiveTab] = useState(localStorage.getItem('deposit.type') || 'crypto');
  const savedRoute = localStorage.getItem('deposit.route');
  const [route, setRoute] = useState(state?.route ?? savedRoute ?? 'funding');
  const [disable, setDisable] = useState(true);
  useEffect(() => {
    if(activeTab){
      setDisable(false);
    }else{
      setDisable(true);
    }
  }, [activeTab]);
  
  const [loading1, setLoading1] = useState(false);
  const [lamount, setLamount] = useState(0);
  const ValidateDeposit = () =>{
    fetch(`${process.env.REACT_APP_API_URL}controller/retirement.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
        "Content-Type": "application/json"
        },
        body: JSON.stringify({ btn_deposit: true, amount: lamount, proof: '', method: 'US Dollar', loan : true  })
    })
    .then(response => response.json())
    .then(data => {
        if (data.status === "success") {
        setLoading1(false);
        toast.success(data.result);
        setTimeout(() => {
          navigate('/transaction', { replace: true })
        }, 2000);
        }else{
          toast.error(data.message);
          setLoading1(false);
        }
    })
    .catch(err => {
        console.error(err)
        setLoading1(false);
    })
  }
  const loanbal = user?.loan_balance;
  const [error, setError] = useState(false);
  function validateAmount (value){
    setLamount(value);
    if((Number(loanbal) * rate) < value || loanbal === 0 || value == 0){
      setError(true);
    }else{
      setError(false);
    }
  }

  if (loading) {
    return <div style={{ textAlign: "center", marginTop: "20%" }}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#ff6b35', opacity: '0.5'}} spin /></div>;
  }

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Deposit" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Deposit" icon={<FontAwesomeIcon icon={faHandHoldingDollar} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="container mt-5">
                <div className="row">
                    <div className="col-lg-8 offset-lg-2 mb-5">
                        <h5 className="mb-0" style={{fontWeight:'900'}}>Make a Deposit</h5>
                        <p className="mb-0">Add funds to your trading account</p>
                        <div className="mt-5 d-flex align-items-center progressD" style={{gap:'20px'}}>
                          <Link to="/deposit" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                              <FontAwesomeIcon icon={faUser} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-prime text-nowrap" style={{fontSize:'12px'}}>Deposit Type</p>
                          </Link>
                          <div style={{height:'3px',maxWidth:'200px',width:'100%'}} className="bg-prime"></div>
                          <Link to="/deposit1" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                              <FontAwesomeIcon icon={faWallet} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-prime text-nowrap" style={{fontSize:'12px'}}>Deposit Method</p>
                          </Link>
                          <div style={{height:'3px',backgroundColor:'#ffffff0c',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/deposit2" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                              <FontAwesomeIcon icon={faCreditCard} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-nowrap" style={{fontSize:'12px'}}>Deposit Details</p>
                          </Link>
                          <div style={{height:'3px',backgroundColor:'#ffffff0c',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/deposit3" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                              <FontAwesomeIcon icon={faArrowUpFromBracket} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-nowrap" style={{fontSize:'12px'}}>Payment Proof</p>
                          </Link>
                          <div style={{height:'3px',backgroundColor:'#ffffff0c',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/deposit4" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                              <FontAwesomeIcon icon={faCircleCheck} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-nowrap" style={{fontSize:'12px'}}>Review & Submit</p>
                          </Link>
                        </div>
                        <div className="mycard p-3 mt-4">
                          <div className="row">
                            <div className="col-12">
                              <h5 className="mb-0" style={{fontWeight:'900'}}>Select Deposit Method</h5>
                              <div className="row">
                                <div className="col-md-6 g-3">
                                  <div className="mycard p-3 d-flex align-items-start justify-content-between" onClick={() => setActiveTab('crypto')} style={{border:activeTab == 'crypto' ? '1px solid #ff6b35' :'1px solid #a9a9a90f'}}>
                                    <div className="d-flex align-items-center">
                                      <div className="d-flex align-items-center justify-content-center rounded-3 mycard p-0" style={{width:'50px',height:'50px'}}>
                                        <FontAwesomeIcon icon={faBitcoinSign} style={{fontSize: '18px'}} className="text-prime" />
                                      </div>
                                      <div className="ms-3">
                                        <p className="mb-0 fw-bold" style={{fontSize:'18px'}}>Cryptocurrency</p>
                                        <div className="d-flex align-items-center" style={{gap:'20px'}}>
                                          <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>Fee: 0%</p>
                                          <div className="rounded-circle bg-secondary" style={{width:'3px',height:'3px'}}></div>
                                          <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>50-30 minutes</p>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="myBtn px-2 py-0 rounded-3 fw-bold" style={{fontSize:'12px'}}>Popular</div>
                                  </div>
                                </div>
                                <div className="col-md-6 g-3">
                                  <div className="mycard p-3 d-flex align-items-start justify-content-between" style={{border:activeTab == 'bank' ? '1px solid #ff6b35' :'1px solid #a9a9a90f'}}>
                                    <div className="d-flex align-items-center">
                                      <div className="d-flex align-items-center justify-content-center rounded-3 mycard p-0" style={{width:'50px',height:'50px'}}>
                                        <FontAwesomeIcon icon={faBank} style={{fontSize: '18px'}} className="text-prime" />
                                      </div>
                                      <div className="ms-3">
                                        <p className="mb-0 fw-bold" style={{fontSize:'18px'}}>Bank Transfer</p>
                                        <div className="d-flex align-items-center" style={{gap:'20px'}}>
                                          <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>Fee: $5</p>
                                          <div className="rounded-circle bg-secondary" style={{width:'3px',height:'3px'}}></div>
                                          <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>1-3 business days</p>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="myBtn px-2 py-0 rounded-3 fw-bold" style={{fontSize:'12px'}}>Unavailable</div>
                                  </div>
                                </div>
                                <div className="col-md-6 g-3">
                                  <div className="mycard p-3 d-flex align-items-start justify-content-between" style={{border:activeTab == 'paypal' ? '1px solid #ff6b35' :'1px solid #a9a9a90f'}}>
                                    <div className="d-flex align-items-center">
                                      <div className="d-flex align-items-center justify-content-center rounded-3 mycard p-0" style={{width:'50px',height:'50px'}}>
                                        <FontAwesomeIcon icon={faWallet} style={{fontSize: '18px'}} className="text-prime" />
                                      </div>
                                      <div className="ms-3">
                                        <p className="mb-0 fw-bold" style={{fontSize:'18px'}}>Paypal</p>
                                        <div className="d-flex align-items-center" style={{gap:'20px'}}>
                                          <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>Fee: 3.5%</p>
                                          <div className="rounded-circle bg-secondary" style={{width:'3px',height:'3px'}}></div>
                                          <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>Instant</p>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="myBtn px-2 py-0 rounded-3 fw-bold" style={{fontSize:'12px'}}>Unavailable</div>
                                  </div>
                                </div>
                                <div className="col-md-6 g-3">
                                  <div className="mycard p-3 d-flex align-items-start justify-content-between" style={{border:activeTab == 'skrill' ? '1px solid #ff6b35' :'1px solid #a9a9a90f'}}>
                                    <div className="d-flex align-items-center">
                                      <div className="d-flex align-items-center justify-content-center rounded-3 mycard p-0" style={{width:'50px',height:'50px'}}>
                                        <FontAwesomeIcon icon={faWallet} style={{fontSize: '18px'}} className="text-prime" />
                                      </div>
                                      <div className="ms-3">
                                        <p className="mb-0 fw-bold" style={{fontSize:'18px'}}>Skrill</p>
                                        <div className="d-flex align-items-center" style={{gap:'20px'}}>
                                          <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>Fee: 2.5%</p>
                                          <div className="rounded-circle bg-secondary" style={{width:'3px',height:'3px'}}></div>
                                          <p className="mb-0 text-secondary fw-semibold" style={{fontSize:'14px'}}>Instant</p>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="myBtn px-2 py-0 rounded-3 fw-bold" style={{fontSize:'12px'}}>Unavailable</div>
                                  </div>
                                </div>
                              </div>
                              <div className="d-flex justify-content-end">
                                {disable ? (
                                    <div className="myBtn mt-4 text-center px-4 py-3 rounded-2 d-block disabled">Next <FontAwesomeIcon icon={faArrowRight} style={{fontSize: '14px'}} /></div>
                                ) : (
                                    <Link to="/deposit2" state={{route:route, type:activeTab}} className="myBtn mt-4 text-center px-4 py-3 rounded-2 d-block" onClick={() => { 
                                      localStorage.setItem('deposit.route', route);
                                      localStorage.setItem('deposit.type', activeTab);
                                    }}>Next <FontAwesomeIcon icon={faArrowRight} style={{fontSize: '14px'}} /></Link>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        {(route == '401k') && (
                        <>
                        <p className="text-center my-3" style={{fontWeight:'900'}}>Pay with Loan Balance</p>
                        <div className="mycard p-3 mt-3 mb-5">
                          <div className="row">
                            <div className="col-md-6">
                              <div className={`mycard p-3 d-flex align-items-center mb-3`} style={{border: '1px solid #a9a9a90f'}}>
                                <div className="d-flex align-items-center justify-content-center rounded-3 mycard p-0" style={{width:'50px',height:'50px'}}>
                                  <FontAwesomeIcon icon={faUsd} style={{fontSize: '18px'}} className="text-prime" />
                                </div>
                                <div className="ms-3">
                                  <p className="mb-0 fw-bold" style={{fontSize:'18px'}}>Loan Balance</p>
                                  <div className="d-flex align-items-center" style={{ gap: '20px' }}>
                                    <p className="mb-0 text-secondary fw-semibold" style={{ fontSize: '14px' }}>
                                      Available Bal.
                                    </p>
                                    <div className="rounded-circle bg-secondary" style={{ width: '3px', height: '3px' }}></div>
                                    <p className="mb-0 text-secondary fw-semibold" style={{ fontSize: '14px' }}>
                                      {getCurrencySymbol(user?.currency)}
                                      {formatCurrency(Number(user?.loan_balance) * rate)}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 ${error ? 'input-error' : ''}`}>
                              <input 
                                type="number"
                                placeholder="1000"
                                className="inputNone"
                                value={lamount}
                                onChange={(e) => validateAmount(e.target.value)}
                              />
                              <div
                                className="fw-bold text-white d-flex align-items-center"
                                style={{
                                    backgroundColor: 'rgb(30, 33, 36)',
                                    borderRadius: '4px',
                                    padding: '6px',
                                    fontSize: '14px',
                                    cursor: 'pointer'
                                }}
                                >
                                {user?.currency}
                              </div>
                          </div>
                          {error && (
                            <p className="mb-0 text-danger fs-7 mt-1">Your current balance is {formatCurrency(user?.loan_balance * rate)} {user?.currency}. Kindly choose a lower amount or deposit into your account.</p>
                          )} 
                          <hr/>
                          <div className="d-flex justify-content-end">
                            <div className={`myBtn text-center px-4 py-3 rounded-2 ${error?'disabled' : null}`} onClick={!error? ValidateDeposit : null}>{loading1?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Submit Deposit'}</div>
                          </div>
                        </div>
                        </>
                        )}
                    </div>
                </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Deposit1